import { useState } from 'react';
import { useAuthContext } from '../../hooks/auth';
import { useClearAppCachesOnMount } from '../../hooks/useClearAppCachesOnMount';
import { Helmet } from 'react-helmet-async';
import { displayWarning } from "../../utils/messageToast";
import { toRespondTickets } from '../../functions/respondTickets';
import { InputsInfosPages } from '../../components/ui/inputs';
import { TextAreaErrors } from '../../components/ui/textArea';
import Modal from '../../components/ui/modal';
import { ButtonClearPendency, ButtonPendency } from '../../components/ui/buttons';
import Editor from '@monaco-editor/react';

export default function Pendency() {
  const { authorizationRA, user } = useAuthContext();
  const ambient = user?.ambient as string;
  const [loadingButton, setLoadingButton] = useState(false);
  const [csvData, setCsvData] = useState<any[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [textAreaValue, setTextAreaValue] = useState<string>('');
  const [protocolData, setProtocolData] = useState<any[]>([]);
  const [pendency, setPendency] = useState<string>('');
  const [isErrors, setIsErrors] = useState(false);
  const [errors, setErrors] = useState<any[]>([]);

  useClearAppCachesOnMount();

  const handleTextAreaValue = async (value: string) => {
    const lines = value.split('\n').map(line => ({ protocol: line }));
    setProtocolData(lines);
  }

  const handlePendency = async () => {
    setLoadingButton(true);
    await new Promise((resolve) => setTimeout(resolve, 3000));
    const updatedProtocolData = protocolData.map(item => ({
      ...item,
      text: pendency,
    }));
    await toRespondTickets(
      ambient,
      authorizationRA,
      updatedProtocolData,
      setCsvData,
      setIsErrors,
      setErrors,
      user?.google?.id,
      user?.google?.name ?? user?.userName ?? null,
      user?.clientId ?? null,
      user?.clientName ?? null
    );
    setPendency('');
    setTextAreaValue('');
    setLoadingButton(false);
    setIsModalOpen(false);
  };

  return (
    <div className="bg-page">
      <Helmet>
        <title>Responder Pendência em massa</title>
      </Helmet>

      <div className="bg-page-create-form-payload w-full px-2 sm:px-4 md:px-6 py-4 payload-page">
        <div className="form-page-shell">
          <div className="form-config-card">
            <div className="form-card-header">
              <div>
                <h2 className="form-card-title">Responder pendências em massa</h2>
                <p className="form-card-subtitle">Defina a mensagem padrão e os protocolos</p>
              </div>
            </div>

            <div className="form-card-body">
              <div className="infos-form-header w-full space-y-3 sm:space-y-4">
                <div className="form-info-row">
                  <label className="form-info-label">Pendência</label>
                  <div className="header-fields-item flex-1 w-full">
                    <InputsInfosPages
                      placeholder='Resposta da pendencia'
                      type='text'
                      value={pendency}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                        setPendency(event.target.value)
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="form-payload-actions is-start">
                <ButtonPendency
                  onClick={async () => {
                    if (!textAreaValue) {
                      displayWarning("Nenhum protocolo informado");
                      return;
                    }
                    setIsModalOpen(true)
                  }}
                />

                <ButtonClearPendency
                  onClick={() => {
                    setTextAreaValue('');
                  }}
                />
              </div>
            </div>
          </div>

          <div className="form-payload-card">
            <div className="form-payload-header">
              <h3 className="form-card-title">Protocolos</h3>
              <p className="form-card-subtitle">Um protocolo por linha</p>
            </div>
            <div className="form-payload-body">
              <div className="form-payload-editor">
                <Editor
                  height="360px"
                  language="text"
                  value={textAreaValue}
                  onChange={(value) => {
                    const next = value ?? '';
                    setTextAreaValue(next);
                    handleTextAreaValue(next);
                  }}
                  theme="vs-light"
                  options={{
                    minimap: { enabled: false },
                    fontSize: 13,
                    lineNumbers: 'on',
                    scrollBeyondLastLine: false,
                    wordWrap: 'on',
                    tabSize: 2,
                    automaticLayout: true,
                  }}
                />
              </div>
            </div>
          </div>

          {isErrors && (
            <div className="form-payload-card">
              <div className="form-payload-header">
                <h3 className="form-card-title">Erros</h3>
                <p className="form-card-subtitle">Itens que falharam no envio</p>
              </div>
              <div className="form-payload-body">
                <TextAreaErrors
                  value={errors}
                  readOnly
                />
              </div>
            </div>
          )}

        {isModalOpen && (
          <Modal
            isOpen={isModalOpen}
            loading={loadingButton}
            onConfirm={handlePendency}
            onClose={() => setIsModalOpen(false)}
          >
            <p className="mb-5 text-base sm:text-lg">Confirma a resposta da pendencia?</p>
          </Modal>
        )}

        </div>
      </div>
    </div>
  );
}
